/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAppTryConnectAzureB2CGet$Params {
  secret?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiAppTryConnectAzureB2CGet(http: HttpClient, rootUrl: string, params?: ApiAppTryConnectAzureB2CGet$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, apiAppTryConnectAzureB2CGet.PATH, 'get');
  if (params) {
    rb.query('secret', params.secret, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

apiAppTryConnectAzureB2CGet.PATH = '/api/app/try-connect-azure-b2c';
